module.exports = __webpack_public_path__ + "img/icon_cogs.92a4db1b.svg";